// extracted by mini-css-extract-plugin
module.exports = {"error":"BackgroundError_error__2gI_M","message":"BackgroundError_message__3ZwSu"};